import { BackButton, OVERLAY_TOP_BAR } from "@/components/navigations";
import { ChromeBar, Text } from "@/components/ui";
import { cn } from "@/lib/cn";

type ItemStickyTitleBarProps = {
  title: string;
  onClose: () => void;
  imageVisible: boolean;
};

/** Fixed bar of the item detail: back button over the photo, then a frosted bar carrying the title once the photo scrolls away. */
export function ItemStickyTitleBar({ title, onClose, imageVisible }: ItemStickyTitleBarProps) {
  return (
    <div className={cn(OVERLAY_TOP_BAR, "pointer-events-none z-raised-3")}>
      <div
        aria-hidden
        data-testid="item-modal-sticky-backdrop"
        className={cn(
          "absolute inset-0 transition-opacity duration-slow ease-standard",
          imageVisible ? "opacity-0" : "opacity-100",
        )}
      >
        <ChromeBar height="auto" className="h-full" />
      </div>
      <BackButton
        label="Fechar detalhes do item"
        data-testid="item-modal-close"
        onClick={onClose}
        onImage={imageVisible}
        className="relative"
      />
      <div
        aria-hidden
        className={cn(
          "relative min-w-0 flex-1 transition-[opacity,transform] duration-slow ease-standard",
          imageVisible ? "translate-x-2 opacity-0" : "translate-x-0 opacity-100",
        )}
      >
        <Text as="span" size="2xl" weight="bold" tone="default" truncate>
          {title}
        </Text>
      </div>
    </div>
  );
}
